import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'

import './style.scss'

ModalSelectReplaceInvoiceMethod.prototype = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  header: PropTypes.string,
  content: PropTypes.string,
  createReplacedReportSelect: PropTypes.func,
  createReplaceAnnounceSelect: PropTypes.func,
  replaceInvoiceSelect: PropTypes.func,
}

function ModalSelectReplaceInvoiceMethod(props) {
  const {
    show,
    setShow,
    header,
    content,
    createReplacedReportSelect,
    createReplaceAnnounceSelect,
    replaceInvoiceSelect,
  } = props

  let handleClose = () => setShow(false)

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="ModalSelectReplaceInvoiceMethod"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <span>
            <i
              className="fa-light fa-triangle-exclamation mr-3"
              style={{ fontSize: 20, color: '#ff9f0e' }}
            ></i>
            {header}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{content}</Modal.Body>
      <Modal.Footer>
        <div className="">
          <button
            className="btn btn-outline-secondary mr-2 px-5"
            onClick={handleClose}
          >
            Hủy bỏ
          </button>
          {createReplacedReportSelect && (
            <button
              className="btn btn-outline-secondary mr-2 px-3"
              onClick={createReplacedReportSelect}
            >
              Lập biên bản
            </button>
          )}

          {/* {createReplaceAnnounceSelect && (
            <button
              className="btn btn-outline-secondary mr-2 px-3"
              onClick={createReplaceAnnounceSelect}
            >
              Lập thông báo
            </button>
          )} */}

          {replaceInvoiceSelect && (
            <button
              className="btn btn-danger px-3"
              onClick={replaceInvoiceSelect}
            >
              Thay thế hóa đơn
            </button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalSelectReplaceInvoiceMethod
